// extracted by mini-css-extract-plugin
export default {"complianceContent":"PatchCompliance_complianceContent__mqLlz"};